import PropTypes from "prop-types";
import React from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";

const PersonalInformationDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Personal Information</h4>
      </div>
      <div className="view-employee-content">
        <ul className="">
          <li>
            <h4>Employee Name</h4>
            <h6>{employee?.fullName}</h6>
          </li>
          <li>
            <h4>DOB</h4>
            <h6>{employee?.dob}</h6>
          </li>
          <li>
            <h4>Gender</h4>
            <h6>
              {employee?.gender === "M"
                ? "Male"
                : employee?.gender === "F"
                ? "Female"
                : "Others"}
            </h6>
          </li>
          <li>
            <h4>Martial Status</h4>
            <h6>{employee?.maritalStatus}</h6>
          </li>
          <li>
            <h4>Acadamic Qualification</h4>
            <h6>{employee?.academicQualification}</h6>
          </li>
          <li>
            <h4>Address </h4>
            <h6>
              {employee?.address1} {employee?.address2} {employee?.address3}
            </h6>
          </li>
          <li>
            <h4>Country</h4>
            <h6>{employee?.country}</h6>
          </li>
          <li>
            <h4>Postal Code</h4>
            <h6>{employee?.postalCode}</h6>
          </li>
          <li>
            <h4>Mobile No</h4>
            <h6>{employee?.hpno}</h6>
          </li>
          <li>
            <h4>Email</h4>
            <h6>{employee?.email}</h6>
          </li>
          <li>
            <h4>Local Contact Number</h4>
            <h6>{employee?.localContactNumber}</h6>
          </li>
          <li>
            <h4>Overseas Contact Number</h4>
            <h6>{employee?.overseasContactNumber}</h6>
          </li>
          <li>
            <h4>Eating Habit</h4>
            <h6>{employee?.eatingHabit}</h6>
          </li>
          <li>
            <h4>Have Kids</h4>
            <h6>{employee?.havingKids ? "Yes" : "No"}</h6>
          </li>
          <li>
            <h4>Have Dependants</h4>
            <h6>{employee?.havingDependants ? "Yes" : "No"}</h6>
          </li>
        </ul>
      </div>
    </div>
  );
};

PersonalInformationDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default PersonalInformationDetails;
